module.exports = __webpack_public_path__ + "img/tk.f77429cd.svg";